import { Component } from '@angular/core';
import { Observable } from 'rxjs';
import { ZendeskMode, ZendeskModeService } from '../services/zendesk-mode.service';

/**
 * Host único do widget de atendimento Zendesk (Messenger).
 *
 * Monta o ZendeskMessengerComponent só quando o `ZendeskModeService` resolve o
 * modo `messenger`. O modo é resolvido uma vez por carregamento de página e não
 * muda com a página carregada (spike PF-4439 no Jira).
 */
@Component({
  selector: 'mandae-zendesk-widget',
  templateUrl: './zendesk-widget.component.html',
})
export class ZendeskWidgetComponent {
  public readonly mode$: Observable<ZendeskMode> = this.modeService.mode$;

  constructor(private modeService: ZendeskModeService) {}
}
